import { makeStyles } from "tss-react/mui";
import { Box, IconButton, Fade, Typography, Button } from "@mui/material";
import { useCallback, useMemo } from "react";
import { Close as CloseIcon } from "@mui/icons-material";

const useStyles = makeStyles()(
  (theme) => ({
    root: {
      height: "56px",
      width: "56px",
      zIndex: 100
    },
    buttonContainer: {
      height: "56px",
      width: "56px",
      borderRadius: theme.spacing(1),
      background: "rgba(240, 242, 245, 0.92)",
      boxShadow: "0 8px 2px 0 rgba(0, 0, 0, 0.00), 0 5px 2px 0 rgba(0, 0, 0, 0.00), 0 3px 2px 0 rgba(0, 0, 0, 0.02), 0 1px 1px 0 rgba(0, 0, 0, 0.03), 0 0 1px 0 rgba(0, 0, 0, 0.03)",
    },
    textButtonContainer: {
      height: "56px",
      width: "auto",
      borderRadius: theme.spacing(1),
      background: "rgba(240, 242, 245, 0.92)",
      boxShadow: "0 8px 2px 0 rgba(0, 0, 0, 0.00), 0 5px 2px 0 rgba(0, 0, 0, 0.00), 0 3px 2px 0 rgba(0, 0, 0, 0.02), 0 1px 1px 0 rgba(0, 0, 0, 0.03), 0 0 1px 0 rgba(0, 0, 0, 0.03)",
    },
    iconButton: {
      width: "100%",
      height: "100%",
      borderRadius: theme.spacing(1)
    },
    textButton: {
      width: "100%",
      height: "100%",
      borderRadius: theme.spacing(1),
      paddingLeft: theme.spacing(2.5),
      paddingRight: theme.spacing(2.5),
      fontSize: "14px !important",
    },
    contentContainer: {
      position: "absolute",
      top: 0,
      left: 0,
      zIndex: 99,
      width: "300px",
      height: `calc(100vh - ${theme.spacing(3)})`,
      borderRadius: theme.spacing(1),
      background: "rgba(240, 242, 245, 0.92)",
      backdropFilter: "blur(2px)",
      boxShadow: "0 8px 2px 0 rgba(0, 0, 0, 0.00), 0 5px 2px 0 rgba(0, 0, 0, 0.00), 0 3px 2px 0 rgba(0, 0, 0, 0.02), 0 1px 1px 0 rgba(0, 0, 0, 0.03), 0 0 1px 0 rgba(0, 0, 0, 0.03)",
    },
    containerContainerRight: {
      right: 0,
      left: "unset"
    },
    contentHeaderContainer: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(1),
      width: "100%",
      borderBottom: `1px solid ${theme.palette.divider}`,
      height: "48px"
    },
    contentBody: {
      position: "absolute",
      top: "48px",
      left: 0,
      width: "100%",
      height: "calc(100% - 48px)",
      overflowX: "hidden",
      overflowY: "auto",
      scrollbarGutter: "stable both-edges",
    },
  })
);

export default function ContainerButton(props) {
  const { className, icon, title, right, width, expanded, setExpanded, slim } = props;
  const { classes } = useStyles();

  const onExpandClick = useCallback(() => {
    setExpanded(true);
  }, [])

  const onCloseClick = useCallback(() => {
    setExpanded(false);
  }, []);

  const containerStyles = useMemo(() => (slim ? { width: "calc(100vw - 24px)", left: "12px", top: "12px", right: "revert", position: "fixed" } : { width }), [width, slim]);

  return (
    <Box className={`${classes.root} ${className || ""}`}>

      <Fade in={!expanded}>
        <Box className={classes.buttonContainer}>
          <IconButton className={classes.iconButton} size="large" onClick={onExpandClick} color="primary">
            {icon}
          </IconButton>
        </Box>
      </Fade>

      <Fade in={expanded}>
        <Box className={`${classes.contentContainer} ${!!right ? classes.containerContainerRight : ""}`} style={containerStyles}>
          <Box className={classes.contentHeaderContainer}>
            {typeof title === "string" ? <Typography variant="subtitle1">{title}</Typography> : title}
            <IconButton onClick={onCloseClick} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
          {
            expanded ? (
              <Box className={classes.contentBody}>
                {props.children}
              </Box>
            ) : null
          }
        </Box>
      </Fade>

    </Box>
  );
}



export function OperationsMapButton(props) {
  const { className, icon, onClick } = props;
  const { classes } = useStyles();

  return (
    <Box className={`${classes.buttonContainer} ${className || ""}`}>
      <IconButton className={classes.iconButton} size="large" onClick={onClick} color="primary">
        {icon}
      </IconButton>
    </Box>
  );
}


export function OperationsMapTextButton(props) {
  const { className, icon, onClick } = props;
  const { classes } = useStyles();

  return (
    <Box className={`${classes.textButtonContainer} ${className || ""}`}>
      <Button className={classes.textButton} size="large" onClick={onClick} color="primary" endIcon={icon}>
        {props.children}
      </Button>
    </Box>
  );
}
